module.exports = __webpack_public_path__ + "static/staking-286b86403a9319712a2fe43a0630565e.svg";